import React from 'react';
import { Box, Tooltip } from '@mui/material';
import SubjectRoundedIcon from '@mui/icons-material/SubjectRounded';

// CanvasPill component for showing canvas availability
export function CanvasPill({
  canvasCount, onClick
}: {
  canvasCount: number;
  onClick: () => void;
}) {
  return (
    <Tooltip title="Show canvas">
      <Box
        component="button"
        onClick={onClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
          border: 'none',
          borderRadius: 12,
          py: 0.2,
          px: 1,
          cursor: 'pointer',
          fontSize: '0.75rem',
          fontWeight: 'medium',
          transition: 'all 0.2s',
          '&:hover': {
            backgroundColor: 'primary.dark',
          },
        }}
      >
        <SubjectRoundedIcon fontSize="small" />
        {canvasCount}
      </Box>
    </Tooltip>
  );
}
